const config = {
  'card-details': {
    pageName: 'cardDetails',
    uri: '/',
  },
  'card-success': {
    pageName: 'cardSuccess',
    uri: '/success',
  },
  'timeout': {
    pageName: 'timeout',
    uri: '/timeout',
  },
  'error': {
    pageName: 'errorPage',
    uri: '/error',
  },
  'loading': {
    pageName: 'processing',
  },
};

Object.entries(config).forEach(([key, val]) => {
  val.key = key;
});

export default config;
